import Button from '../base/Button'

export default function Header () {
  return (
    <header className='bg-white shadow-md sticky top-0 z-50'>
      <div className='container mx-auto px-4 py-4'>
        <div className='flex items-center justify-between'>
          <div className='flex items-center'>
            <img
              src='../../../legacylogo.png'
              alt='Legacy Telecom'
              className='h-6 w-auto sm:h-10 md:h-12'
            />
          </div>

          <nav className='hidden md:flex items-center space-x-8'>
            <a
              href='#planos'
              className='text-gray-700 hover:text-orange-600 font-medium transition-colors cursor-pointer'
            >
              Planos
            </a>
            <a
              href='#sobre'
              className='text-gray-700 hover:text-orange-600 font-medium transition-colors cursor-pointer'
            >
              Sobre
            </a>
            <a
              href='#contato'
              className='text-gray-700 hover:text-orange-600 font-medium transition-colors cursor-pointer'
            >
              Contato
            </a>
          </nav>

          <div className='flex items-center space-x-4'>
            <Button
              variant='outline'
              size='sm'
              href='https://ixc.legacytelecom.net.br/central_assinante_web/login'
            >
              Portal do Assinante
            </Button>
          </div>

          <button className='md:hidden text-gray-700 hover:text-orange-600 cursor-pointer'>
            <i className='ri-menu-line text-2xl'></i>
          </button>
        </div>
      </div>
    </header>
  )
}
